module.exports = __webpack_public_path__ + "img/SAS_Broadsword.965bb18b.png";